import type { Ref, RefCallback } from 'react'

/**
 * Writes `instance` into a React `ref` (callback or object).
 * Object refs use `Reflect.set` so we avoid assigning through a readonly `current` type.
 */
function assignRef<T>(ref: Ref<T> | undefined, instance: T | null) {
  if (ref == null) {
    return
  }

  if (typeof ref === 'function') {
    ref(instance)
    return
  }

  Reflect.set(ref, 'current', instance)
}

/** Single callback ref that forwards the instance to every ref in order. */
export function mergeRefs<T>(...refs: Array<Ref<T> | undefined>): RefCallback<T> {
  return instance => {
    for (const ref of refs) {
      assignRef(ref, instance)
    }
  }
}
